import React, { Component } from 'react';
import {Switch, Route} from 'react-router-dom';
import Create from './create';
import auth from './../../utils/auth'
import ReactDOM from 'react-dom'

export default class CreateFarm extends Component {
  constructor (props) {
    super(props);
    this.state = {
      menus: [
        {
          id: 0,
          title: '创建猪场',
          type: 'farm'
        },
        {
          id: 1,
          title: '创建栋舍',
          type: 'loc'
        },
        {
          id: 2,
          title: '批次维护',
          type: 'batch'
        },
        {
          id: 3,
          title: '员工管理',
          type: 'staff'
        },
        {
          id: 4,
          title: '商品期初',
          type: 'product'
        },
        {
          id: 5,
          title: '猪只管理',
          type: 'swine'
        }
      ]
    }
  }
  jumpTo = (item) => {
    let isMe = auth.readCookie('farm') && auth.readCookie('farm').farmName.indexOf('flame0606') >=0;
   if (isMe) {
     this.props.history.replace(
       {
         pathname: `/createfarm/${item.type}_add`,
         params: {}
       }
     )
   }
  };
  scrollToRight = (el) => {
    const {pathname} = this.props.location;
    let paths = [
      '/createfarm/staff_add',
      '/createfarm/product_add',
      '/createfarm/swine_add'
    ];
    if(paths.indexOf(pathname) >= 0) {
      if(ReactDOM.findDOMNode(el)) {
        ReactDOM.findDOMNode(el).scrollLeft = 225
      }
    }
  };
  render() {
   const {url} = this.props.match;
   const {menus} = this.state;
   const {pathname} = this.props.location;
   const page = pathname.split('/')[2].split('_')[0];
   const type = pathname.split('/')[2].split('_')[1];
   const activeIndex = this.state.menus.findIndex(o => o.type === page);
    return (
    <React.Fragment>
      <Switch>
        <Route path={`${url}/:pageType`}>
          <Create {...this.props}
                  height={window.HEIGHT} />
        </Route>
      </Switch>
      <div style={{display: type === 'edit' ? 'none': 'block'}}
          className={'tooltips-bottom'}
           ref={el=>this.scrollToRight(el)}
      >
        <div className={'content'}>
          {
            menus.map((item,index) => {
              return <section
                  className={index > activeIndex ?'item' : 'item active-text'}
                  key={index}
                  onClick={() => this.jumpTo(item)}>
                {item.title} <span className={index > activeIndex?'arrow': 'active-arrow'} />
              </section>
            })
          }
        </div>
      </div>
    </React.Fragment>
  )
 }
}
